import { memo } from 'react';
import { Outlet, ScrollRestoration } from 'infrastructure/router';
import DashboardOutletWrapper from "./DashboardOutletWrapper";

const DashboardOutletTarget = () => (
    <DashboardOutletWrapper>
        <Outlet />
        <ScrollRestoration />
    </DashboardOutletWrapper>
);

export default memo(DashboardOutletTarget);
